// extracted by mini-css-extract-plugin
export var select = "_nu-0";